import { gql } from "@apollo/client"

const GET_EVENT_GUARDIANS_STAFF = gql`
  query($id: ID!, $perPage: Int!, $page: Int!, $searchTerm: String) {
    event(id: $id) {
      id
      guardians(first: $perPage, page: $page, searchTerm: $searchTerm) {
        data {
          id
          salutation
          forename
          surname
          user_id
        }
      }

      staff(first: $perPage, page: $page) {
        data {
          id
          salutation
          forename
          surname
          user_id
        }
      }
    }
  }
`


export { GET_EVENT_GUARDIANS_STAFF }
